"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const removePersistentData = graphql_tag_1.default `
  mutation($environmentId: String!, $key: String!, $agentId: String) {
    removePersistentData(environmentId: $environmentId, key: $key, agentId: $agentId, type: "REMOVE") {
      environmentId
      key
      value
      agentId
      type
    }
  }
`;
exports.default = removePersistentData;
//# sourceMappingURL=removePersistentData.js.map